import ValueX from '../types/ValueX';

export default class AsNeededX extends ValueX {
    static __className = 'AsNeededX';

    constructor(constructJson) {
        super(constructJson, 'asNeeded', 'AsNeededX');
    }
}
